<script lang="ts">
  import type { Snippet } from 'svelte'
  import Icon from 'shared/javascripts/components/Icon.svelte'
  import chevronUpIcon from 'shared/images/icons/chevron-up.svg'
  import chevronDownIcon from 'shared/images/icons/chevron-down.svg'
  import { scrollIndicators } from 'frontend/inertia/actions/scrollIndicators'

  let {
    open = true,
    children,
  }: {
    open?: boolean
    children: Snippet
  } = $props()

  let canScrollUp = $state(false)
  let canScrollDown = $state(false)
</script>

<div
  class="scrollWrapper"
  use:scrollIndicators={{
    visible: open,
    onChange: (state) => {
      canScrollUp = state.canScrollUp
      canScrollDown = state.canScrollDown
    },
  }}
>
  <div class="scrollIndicator -top" class:hidden={!canScrollUp}>
    <Icon src={chevronUpIcon} />
  </div>

  {@render children()}

  <div class="scrollIndicator -bottom" class:hidden={!canScrollDown}>
    <Icon src={chevronDownIcon} />
  </div>
</div>

<style>
  .scrollWrapper {
    position: relative;
    background-color: var(--color-white);
    --submenu-radius-top: var(--border-radius-lg);
    --submenu-radius-bottom: var(--border-radius-lg);

    box-shadow: var(--box-shadow-1);
    border-radius: var(--submenu-radius-top) var(--submenu-radius-top) var(--submenu-radius-bottom)
      var(--submenu-radius-bottom);
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    scrollbar-width: none;
  }

  .scrollWrapper::-webkit-scrollbar {
    display: none;
  }

  @media (--header-medium-down) {
    .scrollWrapper {
      --submenu-radius-top: 0;
      box-shadow: none;
    }
  }

  .scrollIndicator {
    --indicator-height: 28px;
    position: sticky;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    height: var(--indicator-height);
    pointer-events: none;
  }

  .scrollIndicator :global(.icon) {
    --size: 16px;
  }

  .scrollIndicator.hidden {
    opacity: 0;
  }

  .scrollIndicator.-top {
    top: 0;
    margin-bottom: calc(-1 * var(--indicator-height));
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.85) 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  .scrollIndicator.-bottom {
    bottom: 0;
    margin-top: calc(-1 * var(--indicator-height));
    background: linear-gradient(to top, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0) 100%);
  }
</style>
